import { __decorate, __extends, __metadata, __param } from "tslib";
import { LOGIN_PAGE_URL, RELOAD_MINI_PROGRAM_DESKTOP_URL, WECHAT_WEBVIEW_LOGIN, } from '../../common/constants/login-url';
import LoginRepository from '../../repository/login';
import { Aggregate } from '../../../base/ddd-types/aggregate';
import { INetworkRequestService } from '../../../base/request/network-request.interface';
import { DOCS_WW_LOGIN, LOCATION_HOST, OPEN_WEIXIN_AUTHORIZE, TOC_HOST, } from '../../../config';
import { getQuery } from '@tencent/ark-utils/lib/location';
import { tencentDocOpenUrlForAll } from '@tencent/tencent_doc_open_url';
var LoginAggregate = /** @class */ (function (_super) {
    __extends(LoginAggregate, _super);
    function LoginAggregate(networkRequestService, tinyid) {
        var _this = _super.call(this, tinyid) || this;
        _this.networkRequestService = networkRequestService;
        _this.loginRepository = new LoginRepository(networkRequestService);
        return _this;
    }
    // 小程序列表页
    LoginAggregate.prototype.reloadMiniProgramForDesktop = function () {
        var _a, _b;
        (_b = (_a = window === null || window === void 0 ? void 0 : window.wx) === null || _a === void 0 ? void 0 : _a.miniProgram) === null || _b === void 0 ? void 0 : _b.reLaunch({
            url: RELOAD_MINI_PROGRAM_DESKTOP_URL,
        });
    };
    // 小程序文档登录
    LoginAggregate.prototype.loginDocsInMiniProgram = function (targetUrl) {
        var _a, _b, _c;
        var wxUrl = "/pages/detail/detail?reason=pskey_error&url=".concat(encodeURIComponent(targetUrl));
        if (getQuery('rtkey')) {
            wxUrl += "&scene=".concat(getQuery('rtkey'));
        }
        (_c = (_b = (_a = window.wx) === null || _a === void 0 ? void 0 : _a.miniProgram) === null || _b === void 0 ? void 0 : _b.reLaunch) === null || _c === void 0 ? void 0 : _c.call(_b, {
            url: wxUrl,
        });
    };
    // 企业微信内登录
    LoginAggregate.prototype.loginDocsInWework = function (targetUrl) {
        if (LOCATION_HOST !== TOC_HOST) {
            return;
        }
        var redirectUrl = "".concat(DOCS_WW_LOGIN, "?url=").concat(encodeURIComponent(targetUrl));
        var wWCodeUrl = "".concat(OPEN_WEIXIN_AUTHORIZE, "?appid=ww20388f7040b655b7&redirect_uri=").concat(encodeURIComponent(redirectUrl), "&response_type=code&scope=snsapi_userinfo&state=weworklogin#wechat_redirect");
        location.replace(wWCodeUrl);
    };
    // 微信 H5 跳转登录
    LoginAggregate.prototype.jumpToLoginInWechatWebview = function (targetUrl) {
        tencentDocOpenUrlForAll({
            url: "".concat(WECHAT_WEBVIEW_LOGIN, "?url=").concat(encodeURIComponent(targetUrl), "&wxonly=1"),
            replace: true,
        });
    };
    // 企业微信内 H5 跳转登录
    LoginAggregate.prototype.jumpToLoginInWeworkWebview = function (targetUrl) {
        var url = "".concat(OPEN_WEIXIN_AUTHORIZE, "?appid=ww20388f7040b655b7&redirect_uri=").concat(encodeURIComponent(targetUrl), "&response_type=code&scope=snsapi_userinfo&state=weworklogin#wechat_redirect");
        tencentDocOpenUrlForAll({
            url: url,
            replace: true,
        });
    };
    // 在无法登录自动授权的移动端坏境跳转登录
    LoginAggregate.prototype.jumpToLoginInCommonView = function (targetUrl) {
        tencentDocOpenUrlForAll({
            url: "".concat(LOGIN_PAGE_URL, "?jump_url=").concat(encodeURIComponent(targetUrl)),
            replace: true,
        });
    };
    LoginAggregate.prototype.timOrQQH5Login = function () {
        // QQ/TIM 打开文档结构化消息或链接，一般已有登录态，不太可能出现立即登录banner进到这里
        if (!window.mqq) {
            global.location.reload(); // try to reload
            return;
        }
        window.mqq.invoke('data', 'updateLoginInfo', {
            key: 'pskey',
        }, function () {
            location.reload();
        });
    };
    LoginAggregate = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object, String])
    ], LoginAggregate);
    return LoginAggregate;
}(Aggregate));
export default LoginAggregate;
